import type { PlanPrice } from '../types';

interface PriceValueProps {
  price: PlanPrice;
}

function PriceValue({ price }: PriceValueProps) {
  return (
    <span className="comparison-price-value fs--2">
      {price.originalLabel ? <del>{price.originalLabel}</del> : null}
      <strong className="text-1000">{price.finalLabel}</strong>
    </span>
  );
}

export default PriceValue;
